import { connectHook } from 'app/common/components/connect-hook';
import Topbar from './topbar';
import { useTopbar } from './topbar-hook';

export default connectHook(Topbar, useTopbar);
